import { createSlice, createSelector } from "@reduxjs/toolkit";
import { set } from "date-fns";

const initialState = {
    incomingInvite : null,
    activeGames : [],
    surveyDataToPublish : null
};

const gamesSlice = createSlice({
    name: "games",
    initialState,
    reducers: {
        setIncomingInvite: (state, action) => {
            state.incomingInvite = action.payload;
        },
        addActiveGame: (state, action) => {
            if (!state.activeGames) {
                state.activeGames = [];
            }
            const exists = state.activeGames.find(g => g.gameId === action.payload.gameId);
            if (!exists) {
              state.activeGames.push(action.payload);
            }
          },
          removeActiveGame: (state, action) => {
            state.activeGames = state.activeGames.filter(g => g.gameId !== action.payload);
          },
        
          updateGameState: (state, action) => {
            const { gameId, board, isXNext, winner } = action.payload;
            const gameIndex = state.activeGames.findIndex(g => g.gameId === gameId);
            
            if (gameIndex !== -1) {
              // On met à jour les données du jeu spécifique
              state.activeGames[gameIndex].board = board;
              state.activeGames[gameIndex].isXNext = isXNext;
              state.activeGames[gameIndex].winner = winner;
            }
          },
          clearRoomGames: (state, action) => {
            const roomId = action.payload; 
            state.activeGames = state.activeGames.filter(game => game.roomId !== roomId);
            console.log(`🧹 Nettoyage des jeux locaux pour la room : ${roomId}`);
          },
          setSurveyDataToPublish: (state, action) => {
            state.surveyDataToPublish = action.payload;
          },
          clearSurveyData: (state) => {
            state.surveyDataToPublish = null;
          },
          castVote: (state, action) => {
            const { gameId, voterId, voterName, selectedOptions } = action.payload;
            
            const game = state.activeGames.find(g => g.gameId === gameId);
            if (game) {
              if (!game.votes) game.votes = {};
              
              game.votes[voterId] = {
                name: voterName,
                choices: selectedOptions
              };
            }
          },
    }
});

export const { 
    setIncomingInvite,
    addActiveGame,
    removeActiveGame,
    updateGameState,
    clearRoomGames,
    setSurveyDataToPublish,
    clearSurveyData,
    castVote 
} = gamesSlice.actions;

export default gamesSlice.reducer